import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Button, Form, FormGroup, Label, Input, Container } from "reactstrap";
import SelectBoxSearch from "../../common/SelectBoxSearch";
import SelectBoxSearchAssetItem from "../../common/SelectBoxSearchAssetItem";
import useFormValidation from "../../common/useFormValidation";
import { TimePicker } from "react-time-picker";
import moment from "moment";
import "../../../style/employee.css";
import api from "../../../apis/api";
import { getMinAllowedDate } from "../../../config/unlockConfig";
import Notifications from "../../../components/common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const FormApplyLeave = React.memo((props) => {
  const {
    selectedItem,
    selectedAsset,
    userList,
    handleAddAsset,
    handleUpdateAsset,
    assetItemList,
    typeleaveList,
    holidaycal,
    WeekdayId,
    handlecancel,
    CalendarYearList,
    employeedetails,
    empTask,
    curProjectId
  } = props;
  var loginUser = JSON.parse(localStorage.getItem("user"));
  const [itemNo, setItemNo] = useState(0);
  const [itemModel, setItemModel] = useState("");
  const [itemUniqueId, setItemUniqueId] = useState("");
  const [itemModelNo, setItemModelNo] = useState("");
  const [itemUser, setItemUser] = useState(0);
  const [warrantyEndDate, setWarrantyEndDate] = useState("");
  const [warrentyFile, setWarrentyFile] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, settoDate] = useState("");
  const [vendor, setVendor] = useState("");
 const [itemId,setItemId]=useState(0);
  const [options,setOptions ]=useState([]);
  const [selectedOption,setSelectedOption]=useState("");
  const [isViewtodate,setisViewtodate]=useState(false);
  const [isViewtime,setisViewtime]=useState(false);
  const [isDayCount,setisDayCount]=useState(true);
  const [curRadiobutton,setcurRadiobutton] =useState(0);
  const [datediff,setdatediff]=useState(0);
  const [fromtime,setfromtime]=useState("9.30");
  const [totime,settotime]=useState("");
  const [dutytype,setdutytype]=useState("");
  const [fromdutytype,setfromdutytype]=useState(1);
  const [todutytype,settodutytype]=useState(1);
  const [leavetype,setleavetype]=useState(1);
  const [leavetypekey,setleavetypekey]=useState("");
  const [reason,setreason]=useState("");
  const [contactdetails,setcontactdetails]=useState("");
  const [handover,sethandover]=useState("");
  const [error, setError] = useState(null);
  const [error1, setError1] = useState(null);
  const [employeelist,setemployeelist]=useState([]);
  const [daysCount,setDaysCount]=useState(0);
  // for item inside asset.
  const [
    formValidationStateAssetItem,
    setFormValidationStateAssetItem,
  ] = useState({});
  const callValidationAssetItem = useRef(false);

  const { formValidation, isFormValid } = useFormValidation(
    formValidationStateAssetItem
  ); // for item inside asset.
  const [loaded, setLoaded] = useState(false);
  const [sandwichWarning, setSandwichWarning] = useState("");

  const isExceptionLeaveType = (leaveTypeId, typeleaveList) => {
    const selected = typeleaveList?.find(x => parseInt(x.leaveTypeId) === parseInt(leaveTypeId));
    if (!selected) return false;
    const name = selected.type?.toLowerCase() || "";
    return name.includes("maternity") || 
           name.includes("miscarriage") ||
           name.includes("lmc") ||
           name.includes("bereavement") ||
           name.includes("paternity") ||
           name.includes("special medical");
  };

  const getWorkingDaysCount = (from, to, holidaylist) => {
    const dt1 = new Date(from);
    const dt2 = new Date(to);
    dt1.setHours(0, 0, 0, 0);
    dt2.setHours(0, 0, 0, 0);
    
    const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;
    const isHoliday = (d) => holidaylist?.some(
      (h) => new Date(h).toDateString() === d.toDateString()
    );
    const isNonWorkingDay = (d) => isWeekend(d) || isHoliday(d);
    
    let workingDays = 0;
    let temp = new Date(dt1);
    while (temp <= dt2) {
      if (!isNonWorkingDay(temp)) {
        workingDays++;
      }
      temp.setDate(temp.getDate() + 1);
    }
    return workingDays;
  };

  const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
      props.disappear &&
      css`
    display: block; /* show */
  `}
`;
  let holidaylist=[];
  if(Array.isArray(holidaycal) && holidaycal.length > 0) 
    {
    holidaycal.map(function (hol){
      holidaylist.push(new Date(hol.holidayDate));
    })
  }

  let weekIdlist=[];
  if(Array.isArray(WeekdayId)) {
    WeekdayId.map(function (hol){
      weekIdlist.push(hol.weekdayId);
    })
  }
  useEffect(() => {
    // calls when asset item's add&edit form is submited.
    callValidationAssetItem.current && callBackAfterValidationAssetItem();
  }, [formValidation]);

  useEffect(()=>{
    //console.log("assetItemList",assetItemList)
    let empArr1 = [];
    const fetchApi = async () => {
      const response = await api.empSkill().GetAllEmployeeList();
      response.data.forEach((element) => {
        if (element.isActive) { // Only push if active
          empArr1.push({
            value: element,
            label: element.employeeName,
            empId: element.employeeId
          });
        }
      });

      setemployeelist(empArr1);
    }
    fetchApi();
    if(assetItemList!=null){
      let empArr = [];

      //only show software Type Assets in Asset Options
      assetItemList.filter(n=>n.itemType == 1).forEach((element) => {
        empArr.push({ value: element, label: element.itemName,itemId:element.itemId });
      });
      setOptions(empArr);

    }
    if (employeedetails.length > 0) 
      {
      setcontactdetails(employeedetails[0].mobileNumber);
    }
  },[assetItemList,setemployeelist,setcontactdetails,employeedetails])
  const validateMobileNumber = (number) => {
    const regex = /^[6-9]\d{9}$/; // Indian mobile number validation (10 digits starting with 6, 7, 8, or 9)
    return regex.test(number);
  };
  const handleCance =(e) =>{
    e.preventDefault();
    handlecancel();
  }
  const handleChange = (e) => {
    const value = e;
    setcontactdetails(value);

    if (!validateMobileNumber(value) && value !== "") {
      setError1("Invalid mobile number. Please enter a valid 10-digit number.");
    } else {
      setError1("");
    }
  };
  // useEffect(() => {

  // }, [selectedItem, selectedAsset, userList]);
  let dayArr = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // function
  const handleFormSubmit = (e) => {
    e.preventDefault();


  };
  const countHolidaysInRange = (fromDate, toDate, holidaylist) => {
    const dt1 = new Date(fromDate);
    const dt2 = new Date(toDate);

    return holidaylist.filter((holiday) => {
      const hDate = new Date(holiday);
      return hDate >= dt1 && hDate <= dt2;
    }).length;
  };
  // asset item valdation's and ADD&EDIT call.
 const date_diff_indays = (fromDate, toDate, holidaylist = [], empTask = []) => {
    const dt1 = new Date(fromDate);
    const dt2 = new Date(toDate);

    // normalize to midnight to avoid time drift
    dt1.setHours(0, 0, 0, 0);
    dt2.setHours(0, 0, 0, 0);

    const isWeekend = (d) => d.getDay() === 0 || d.getDay() === 6;
    const isHoliday = (d) => holidaylist?.some(
      (h) => new Date(h).toDateString() === d.toDateString()
    );
    const isNonWorkingDay = (d) => isWeekend(d) || isHoliday(d);

    // Helper: check if a leave exists on a specific date (from empTask)
    const hasLeaveOn = (date) =>
      Array.isArray(empTask) && empTask.some((task) => {
        const typeName = (task.Type || task.type || task.leaveType || "").toLowerCase();
        if (typeName.includes("encash")) return false;
        const taskFrom = new Date(task.fromDate || task.leaveFromDate || task.dateFrom);
        const taskTo = new Date(task.toDate || task.leaveToDate || task.dateTo);
        taskFrom.setHours(0, 0, 0, 0);
        taskTo.setHours(0, 0, 0, 0);
        const check = new Date(date);
        check.setHours(0, 0, 0, 0);
        return check >= taskFrom && check <= taskTo && task.leaveStatus !== "Rejected";
      });

    const getChainStart = (start) => {
      let currentStart = new Date(start);
      let d = new Date(start);
      while (true) {
        d.setDate(d.getDate() - 1);
        if (!isNonWorkingDay(d)) {
          if (hasLeaveOn(d)) {
            currentStart = new Date(d);
          } else {
            break;
          }
        } else {
          // Check if there is any leave further back
          let temp = new Date(d);
          let foundLeave = false;
          while (true) {
            temp.setDate(temp.getDate() - 1);
            if (!isNonWorkingDay(temp)) {
              if (hasLeaveOn(temp)) {
                foundLeave = true;
              }
              break;
            }
          }
          if (foundLeave) {
            // continue tracing back
          } else {
            break;
          }
        }
      }
      return currentStart;
    };

    const getChainEnd = (end) => {
      let currentEnd = new Date(end);
      let d = new Date(end);
      while (true) {
        d.setDate(d.getDate() + 1);
        if (!isNonWorkingDay(d)) {
          if (hasLeaveOn(d)) {
            currentEnd = new Date(d);
          } else {
            break;
          }
        } else {
          // Check if there is any leave further forward
          let temp = new Date(d);
          let foundLeave = false;
          while (true) {
            temp.setDate(temp.getDate() + 1);
            if (!isNonWorkingDay(temp)) {
              if (hasLeaveOn(temp)) {
                foundLeave = true;
              }
              break;
            }
          }
          if (foundLeave) {
            // continue tracing forward
          } else {
            break;
          }
        }
      }
      return currentEnd;
    };

    let workingDays = 0;
    let temp = new Date(dt1);
    while (temp <= dt2) {
      if (!isNonWorkingDay(temp)) {
        workingDays++;
      }
      temp.setDate(temp.getDate() + 1);
    }

    const isException = isExceptionLeaveType(leavetype, typeleaveList);
    if (isException) {
      return workingDays;
    }

    const chainStart = getChainStart(dt1);
    const chainEnd = getChainEnd(dt2);

    // Find all tasks from empTask that are inside the chain and sum their NoOfDays
    let sumOfOtherLeaves = 0;
    if (Array.isArray(empTask)) {
      empTask.forEach((task) => {
        if (task.leaveStatus === "Rejected") return;
        const typeName = (task.Type || task.type || task.leaveType || "").toLowerCase();
        if (typeName.includes("encash")) return;
        const taskFrom = new Date(task.fromDate || task.leaveFromDate || task.dateFrom);
        const taskTo = new Date(task.toDate || task.leaveToDate || task.dateTo);
        taskFrom.setHours(0, 0, 0, 0);
        taskTo.setHours(0, 0, 0, 0);

        // If the task falls within the chain boundaries
        if (taskFrom >= chainStart && taskTo <= chainEnd) {
          // Exclude the current task's range (which is [dt1, dt2])
          if (taskTo < dt1 || taskFrom > dt2) {
            const taskNoOfDays = task.noOfDays || task.daysCount || task.NoOfDays || 0;
            sumOfOtherLeaves += taskNoOfDays;
          }
        }
      });
    }

    const sameDay = dt1.toDateString() === dt2.toDateString();
    let currentRequestDays = workingDays;
    if (sameDay) {
      if (parseInt(fromdutytype) === 2 || parseInt(todutytype) === 2) {
        currentRequestDays = 0.5;
      }
    } else {
      if (parseInt(fromdutytype) === 2) currentRequestDays -= 0.5;
      if (parseInt(todutytype) === 2) currentRequestDays -= 0.5;
    }

    const totalLeaveDays = sumOfOtherLeaves + currentRequestDays;

    let totalCharge = workingDays;

    if (totalLeaveDays >= 4) {
      // Sandwich rule applies to the chain!
      // Total calendar days in the chain
      let totalChainDays = 0;
      temp = new Date(chainStart);
      while (temp <= chainEnd) {
        totalChainDays++;
        temp.setDate(temp.getDate() + 1);
      }

      totalCharge = Math.max(workingDays, totalChainDays - sumOfOtherLeaves);
    }

    return totalCharge;
  };

  function getDatesInRange(startDate, endDate) {
    const date =new Date(startDate);
  const enddate=new Date(endDate)
    const dates = [];

    while (date <= enddate) {
      dates.push(moment(new Date(date)).format("YYYY-MM-DD"));
      date.setDate(date.getDate() + 1);
    }

    return dates;
  }
  function getDayName(dateStr, locale)
   {
    var date = new Date(dateStr).getDay();
    return date;        
   }

  const setTodatechanes=React.useCallback((todate) =>{

    settoDate(todate);
    settodutytype(1);
   if(fromDate !='')
    {
      const newdatediff=date_diff_indays(fromDate,todate,holidaylist,empTask);

      var getDaysArray = getDatesInRange(fromDate, todate)
      let count=0;
      let hollist=[];
      getDaysArray.map(function (day){
        // var day = getDayName(day, "en-IN");
        var outlist=holidaylist.some(item => item === day);
        if(outlist==true)
        {
          hollist.push(outlist);
        }
      
      })
     if(newdatediff<=0)
        {
          setError({ ...error, message: "To Date must be greater than From Date" , status: 500 });
         setdatediff(0);
        }
     else
     {
      setdatediff(newdatediff);
      
     }

    }
    else
    {
      setError({ ...error, message: "To Date must be greater than From Date" , status: 500 });
      setdatediff(0);
    }
 
  },[fromDate,datediff,settodutytype,empTask])
  const checkwithinactiveyaer =(datefor) =>{
   const yearlist=CalendarYearList.filter(x => x.isActive == true);
   const monthfrom=new Date(yearlist[0].monthDurationFrom);
   const monthTo=new Date(yearlist[0].monthDurationTo);
   const dateto=new Date(datefor);
   if(dateto >=monthfrom && dateto<=monthTo)
   {
    return true;
   }
   else{
    return false;
   }
  };
  const setFromdatechanes=React.useCallback((todate) =>{

    const statusdate= checkwithinactiveyaer(todate);
    setFromDate(todate);
    setfromdutytype(1);
   if(todutytype == 2 || fromdutytype == 2)
    {
      setdatediff(datediff - .5);
    }
    if(toDate != '')
    {
      const newdatediff=date_diff_indays(todate,toDate,holidaylist,empTask);

      var getDaysArray = getDatesInRange(todate, toDate)
      let count=0;
      let hollist=[];
      getDaysArray.map(function (day){
        // var day = getDayName(day, "en-IN");
        var outlist=holidaylist.some(item => item === day);
        if(outlist==true)
        {
          hollist.push(outlist);
        }
      
      })
     if(newdatediff<=0)
        {
          setError({ ...error, message: "To Date must be greater than From Date" , status: 500 });
         setdatediff(0);
        }
      //  else if(newdatediff >=5 && hollist.length >0)
      //  {
      //   setdatediff(newdatediff);

      //  }
      //  else if(newdatediff<5 && hollist.length ==0)
      //  {
      //   setdatediff(newdatediff);
      //  }
      else
     {
      setdatediff(newdatediff);
     }
    //  else if(newdatediff<5 && hollist.length >0)
    //  {
    //   setdatediff(newdatediff-hollist.length);
    //  }
     
    //  else
    //  {
    //   setdatediff(newdatediff-hollist.length);
    //  }
    }
    else{
      // setError({ ...error, message: "ToDate must be greater than FromDate" , status: 500 });
      setdatediff(0);
    }
    // if(dutytype == "")
    // {
    //   alert("Select duty type.");
    //   setFromDate("")
    // }
 
  },[fromDate,dutytype,empTask,todutytype,fromdutytype,datediff,setfromdutytype])
 const handleonchangeFromduetytype = React.useCallback((type) => {
  setfromdutytype(type);
    if (fromDate && toDate) {
      let newdatediff = date_diff_indays(fromDate, toDate, holidaylist, empTask);
      if (parseInt(type) === 2 || parseInt(todutytype) === 2) {
        newdatediff -= 0.5;
      }
      setdatediff(newdatediff);
    }
  }, [fromDate, toDate, todutytype, holidaylist, empTask]);
  const handleonchangeToduetytype = React.useCallback((type) => {
    settodutytype(type);
    if (fromDate && toDate) {
      let newdatediff = date_diff_indays(fromDate, toDate, holidaylist, empTask);
      if (parseInt(type) === 2 || parseInt(fromdutytype) === 2) {
        newdatediff -= 0.5;
      }
      setdatediff(newdatediff);
    }
  }, [fromDate, toDate, fromdutytype, holidaylist, empTask]);
  const toggleradiobutton =(e) =>{
    setcurRadiobutton(e);
    if(e==1) 
      {
      setisViewtodate(false);
      setisViewtime(true);

    }
    else if(e==2)
    {
      setisViewtodate(false);
      setisViewtime(false);
    }
    else
    {
      setisViewtodate(true);
      setisViewtime(false);
    }
    
  }
  const handleonchangeduetytype =(e,key) =>{
    setleavetype(e);
    setleavetypekey(key);
    if(e=='79')
    {
    setFromDate(new Date());
    settoDate(new Date());
    sethandover("n");
    }
  }
  const formValidationOnSubmit = React.useCallback(
    (e) => {
      e.preventDefault();
      let formValidationList = {
        // key name should be same as the input field name to represtent in form.
        leavetype: {
          required: true,
          isValid: true,
          value: leavetype,
          errorMessage: "",
        },
        fromDate: {
          required: true,
          isValid: true,
          value: fromDate,
          errorMessage: "",
        },
        toDate: {
          required: true,
          isValid: true,
          value: toDate,
          errorMessage: "",
        },
        reason: {
          required: true,
          isValid: true,
          value: reason,
          errorMessage: "",
        },
        handover: {
          required: true,
          isValid: true,
          value: handover,
          errorMessage: "",
        },
        contactdetails: {
          required: true,
          isValid: true,
          value: contactdetails,
          errorMessage: "",
        },
        daysCount: {
          required: true,
          isValid: true,
          value: daysCount,
          errorMessage: "",
        },
      };
      setFormValidationStateAssetItem(formValidationList); //this set call the custom hook useFormValidation.
      callValidationAssetItem.current = true;
    },
    [leavetype, fromDate,toDate,reason,handover,contactdetails,daysCount]
  );
function formatForApi(date) {
  // Ensure string "YYYY-MM-DDTHH:mm:ss"
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}T00:00:00`;
}

  // asset add after validation.
  const callBackAfterValidationAssetItem = React.useCallback(() => {
    if (isFormValid) {

      setLoaded(true);
      // if form valid.
      let formData = {};
      // console.log(typeof warrentyFile);

      // console.log(itemUser?.value?.employeeId ?? 0);
      try{
        const phoneRegex = /^[0-9]{10}$/;
        const isFormValid =
          leavetype.trim() !== "" &&
          reason.trim() !== "" &&
          handover.trim() !== "" &&
          contactdetails.trim() !== "" &&
          phoneRegex.test(contactdetails); // Contact should be a valid 10-digit number

        if (isFormValid == true) {

           if(leavetype !='79')
  {
     if(datediff > 0)
     {
          formData = {
           leaveTypeId:parseInt(leavetype),
           employeeId:parseInt(loginUser.EmployeeId),
           fromDate:formatForApi(fromDate), // ✅ "2025-05-23" (YYYY-MM-DD)
           toDate:formatForApi(toDate),
           noOfDays:datediff,
           reason:reason,
           workhandOverTo:handover,
           contactDetails:contactdetails,
           projectId:curProjectId??0
          };
          const fetchApi2 = async () => {
          const res=await api.dbCalendarYear().AddEditLeaveApply(formData).then(response =>{
     
            if(response.status == 201)
            {
              setError({ ...error, message: response.data , status: 500 });
              setTimeout(() => { 
                setLoaded(false);
              
            }, 3000);
            }
            else{
              setError({ ...error, message: "Leave Applied." , status: 200 });
               setLoaded(false);
              setTimeout(() => { 
                window.location.reload();
            }, 3000);
            }

                  //   if(response.data == 'You already applied Leave on this selected Date Range.')
                  //  {
                  //  setError({ ...error, message: "Leave applied successfully..", status: 200 });



                  //  }

                });

              }
              fetchApi2();
            }
            else 
              {
              setError({ ...error, message: "Days must be greater than 0" , status: 500 });
              setTimeout(() => {
                setLoaded(false);

              }, 3000);
            }
          }
         else{
         formData = {
           leaveTypeId:parseInt(leavetype),
           employeeId:parseInt(loginUser.EmployeeId),
          fromDate:formatForApi(fromDate), // ✅ "2025-05-23" (YYYY-MM-DD)
           toDate:formatForApi(toDate),
           noOfDays:daysCount,
           reason:reason,
           workhandOverTo:'',
           contactDetails:contactdetails,
           daysCount:daysCount,
           projectId:curProjectId??0
          };
          const fetchApi2 = async () => {
          const res=await api.dbCalendarYear().AddEditLeaveApply(formData).then(response =>{
     
            if(response.status == 201)
            {
              setError({ ...error, message: response.data , status: 500 });
              setTimeout(() => { 
                setLoaded(false);
              
            }, 3000);
            }
            else{
              setError({ ...error, message: "Leave Applied." , status: 200 });
              setTimeout(() => { 
                setLoaded(false);
                window.location.reload();
                
            }, 3000);
                }

                //   if(response.data == 'You already applied Leave on this selected Date Range.')
                //  {
                //  setError({ ...error, message: "Leave applied successfully..", status: 200 });



                //  }

              });

            }
            fetchApi2();
          }
        }
        else
    {
      setTimeout(() => { 
        setLoaded(false);
      
    }, 3000);
    }
         //  console.log(res);
         }
         catch(ex)
         {
  
         }
      }
     
  }, [isFormValid, handleFormSubmit,leavetype,fromDate,toDate,datediff,reason,handover,contactdetails]);

  React.useEffect(() => {
    if (fromDate && toDate && leavetype) {
      const isException = isExceptionLeaveType(leavetype, typeleaveList);
      if (isException) {
        const totalDaysWithSandwich = date_diff_indays(fromDate, toDate, holidaylist, empTask);
        const workingDaysOnly = getWorkingDaysCount(fromDate, toDate, holidaylist);
        if (totalDaysWithSandwich > workingDaysOnly) {
          setSandwichWarning("This leave falls under the sandwich leave policy. Saturday and Sunday will be treated as Loss of Pay (LOP).");
        } else {
          setSandwichWarning("");
        }
      } else {
        setSandwichWarning("");
      }
    } else {
      setSandwichWarning("");
    }
  }, [fromDate, toDate, leavetype, holidaylist, empTask, typeleaveList]);

  return (
    <Container>
      <Form onSubmit={formValidationOnSubmit}>

        <Row form>
          <Col md={6}>
            <FormGroup>
              <Label for="exampleEmail">Leave Type</Label>
              <Input
                type="select"
                name="select"
                onChange={(e) => handleonchangeduetytype(e.target.value,e.target.key)}
              >
                <option value="">select Leave Type</option>
                {typeleaveList.map((el) => (
                  <option value={el.leaveTypeId} key={el.type}>{el.type}</option>
                ))}
                {/* <option value="">select Type</option>
                <option value="1">Work From Home</option>
                <option value="2">Attendence Override</option> */}

              </Input>
              {Object.keys(formValidation).length !== 0 &&
                !formValidation.leavetype.isValid && (
                  <span className=" " style={{ color: "red" }}>
                    {formValidation.leavetype.errorMessage}
                  </span>
                )}
            </FormGroup>
          </Col>

        </Row>

        {leavetype != '79' ? (<div><Row form>
          <Col md={3}>
            <FormGroup>
              <Label for="exampleEmail">From</Label>
              <DatePicker
                style={{ width: "100%" }}

                selected={fromDate}
                excludeDates={holidaylist}
                dateFormat="dd-MM-yyyy"
                minDate={getMinAllowedDate()} // Set your start date
                maxDate={new Date('2027-03-31')} // Set your end date
                onChange={(e) => {
                  if (e) {
                    e.setHours(0, 0, 0, 0); // Ensure time is 00:00:00
                    setFromdatechanes(e);
                  } else {
                    setFromdatechanes(null);
                  }
                }}
                name="fromDate"
              // style={inputHeight}
              />
              {/* <Input
              type="date"
              value={fromDate}
              name="fromDate"
              // value={
              //   employeeDetails?.dateOFBirth?.substring(0, 10) ?? new Date()
              // }
           
              onChange={(e) =>
                setFromdatechanes(e)
              }
              // style={inputHeight}
            /> */}
              {Object.keys(formValidation).length !== 0 &&
                !formValidation.fromDate.isValid && (
                  <span className=" " style={{ color: "red" }}>
                    {formValidation.fromDate.errorMessage}
                  </span>
                )}
            </FormGroup></Col>
          <Col md={3}>
            <FormGroup>
              <Label for="exampleEmail">Type</Label>
              <Input
                type="select"
                name="select"
                value={fromdutytype}
                onChange={(e) => handleonchangeFromduetytype(e.target.value)}
              >

                <option value="1">Full Day</option>
                <option value="2">Half Day</option>

              </Input>
            </FormGroup></Col>
          <Col md={6}>
            <FormGroup>

              <br/>
              <Label>Days {curRadiobutton == 1 ? .5 : (curRadiobutton == 2 ? 1 : datediff === 0 ? 0 : datediff)}</Label>
              {sandwichWarning && (
                <div className="alert alert-warning mt-2 p-2" style={{ fontSize: "12px", maxWidth: "400px" }}>
                  {sandwichWarning}
                </div>
              )}

            </FormGroup>
          </Col>
        </Row>
          <Row form>
            <Col md={3}>
              <FormGroup><Label for="exampleEmail">To</Label>
                <DatePicker selected={toDate} name="toDate" excludeDates={holidaylist} dateFormat="dd-MM-yyyy"
                  minDate={fromDate || getMinAllowedDate()} // Set your start date
                  maxDate={new Date('2027-03-31')} // Set your end date
                  onChange={(e) => {
                    if (e) {
                      e.setHours(0, 0, 0, 0); // Ensure time is 00:00:00
                      setTodatechanes(e);
                    } else {
                      setTodatechanes(null);
                    }
                  }}  />
                {/* <Input
              type="date" value={toDate} name="toDate"  onChange={(e) => setTodatechanes(e)}
            /> */}
                {Object.keys(formValidation).length !== 0 &&
                  !formValidation.toDate.isValid && (
                    <span className=" " style={{ color: "red" }}>
                      {formValidation.toDate.errorMessage}
                    </span>
                  )}
              </FormGroup>


            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="exampleEmail">Type</Label>
                <Input
                  type="select"
                  name="select"
                  value={todutytype}
                  onChange={(e) => handleonchangeToduetytype(e.target.value)}
                >
                  <option value="1">Full Day</option>
                  <option value="2">Half Day</option>

                </Input></FormGroup>


            </Col>
          </Row>
          {isViewtime == true ?(<Row form>
        <Col md={3}>
          <FormGroup>
            <Label>Time From</Label>
            <TimePicker
             onChange={(e) => {
              setfromtime(e);
                }} 
                
                 value={moment(fromtime, "hhmm").format("HH:mm") }
                 format="HH:mm" closeClock={false} disableClock={true} 
                // selected={moment(fromtime, "hhmm").format("HH:mm")  } 
                locale="sv-sv"/>
          </FormGroup>
          </Col>
          <Col md={3}>
          <FormGroup>
            <Label>Time To</Label>
            <TimePicker 
            // onChange={(e) => {
            //       val.handleOnChange(e);
            //     }} 
                // placeholder={val.placeholder}
                
                 value={moment("2.00", "hhmm").format("HH:mm") } 
                format="HH:mm" closeClock={false} disableClock={true} 
                // selected={moment(fulldayworkval, "hhmm").format("HH:mm")  }
                 locale="sv-sv"/>
              </FormGroup>
            </Col>
          </Row>) :null}  </div>) : (<div>
            <Row form>
              <Col md={6}>

                <FormGroup>
                  <Label for="examplePassword">Days</Label>
                  <Input
                    type="number"
                    value={daysCount}
                    name="daysCount"
                    onChange={(e) => setDaysCount(e.target.value)}
                  />
                  {Object.keys(formValidation).length !== 0 &&
                    !formValidation.daysCount.isValid && (
                      <span className=" " style={{ color: "red" }}>
                        {formValidation.daysCount.errorMessage}
                      </span>
                    )}
                </FormGroup>

              </Col>

            </Row>
          </div>)}

        <Row form>
          <Col md={6}>

            <FormGroup>
              <Label for="examplePassword">Reason</Label>
              <Input
                type="text"
                value={reason}
                name="reason"
                onChange={(e) => setreason(e.target.value)}
              />
              {Object.keys(formValidation).length !== 0 &&
                !formValidation.reason.isValid && (
                  <span className=" " style={{ color: "red" }}>
                    {formValidation.reason.errorMessage}
                  </span>
                )}
            </FormGroup>

          </Col>

        </Row>
        {leavetype != '79' ? (<Row form>
          <Col md={6}>

            <FormGroup>
              <Label for="examplePassword">HandOver To</Label>
              <SelectBoxSearch
                options={employeelist}
                // selectedUser={handover}
                onChange={(e) => sethandover(e.label)}
              ></SelectBoxSearch>
              {/* <Input
              type="text"
              value={handover}
              name="handover"
              onChange={(e) => sethandover(e.target.value)}
            /> */}
              {Object.keys(formValidation).length !== 0 &&
                !formValidation.handover.isValid && (
                  <span className=" " style={{ color: "red" }}>
                    {formValidation.handover.errorMessage}
                  </span>
                )}
            </FormGroup>

          </Col>

        </Row>):null }
        <Row form>
          <Col md={6}>

            <FormGroup>
              <Label for="examplePassword">Contact Details</Label>
              <Input
                type="text"
                value={contactdetails}
                name="contactdetails"
                onChange={(e) => handleChange(e.target.value)}
              />
              {error1 && <small style={{ color: "red" }}>{error1}</small>}
              {Object.keys(formValidation).length !== 0 &&
                !formValidation.contactdetails.isValid && (
                  <span className=" " style={{ color: "red" }}>
                    {formValidation.contactdetails.errorMessage}
                  </span>
                )}
            </FormGroup>

          </Col>

        </Row>
        <Row>
          <Col className="text-center">
            <Button
              type="submit"
              color=""
              className="btn-admin-settings"
              onClick={formValidationOnSubmit}
            >
              {selectedAsset !== "" ? "Apply" : "Add"}
            </Button>
            &nbsp;
            <Button color="" className="btn-cancel" onClick={handleCance}>
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
      <Notifications notifications={error}></Notifications>
      <DarkBackground disappear={loaded}>
        <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
      </DarkBackground>
    </Container>
  );
});

export default FormApplyLeave;
